import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import PageHeader from "../../common/components/PageHeader";
import FAQAccordion from "./FAQAccordion";

const FAQ = () => {
    return (
        <Box sx={{ p: 4 }}>
            <PageHeader
                title="My DCP FAQs"
                content={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography color="text.secondary" sx={{ fontSize: 14 }}>
                            Account
                        </Typography>
                        <FiberManualRecord sx={{ fontSize: 8, color: 'text.secondary' }} />
                        <Typography color="text.secondary" sx={{ fontSize: 14 }}>
                            My DCP FAQs
                        </Typography>
                    </Stack>
                }
            />
            <FAQAccordion />
        </Box>
    )
}

export default FAQ;